/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel
} from '@salesforce/retail-react-app/app/components/shared/ui'

const FocusedAccordion = ({AccordionPanelContent, AccordionButtonContent}) => {
    const [isAccordionOpen, setIsAccordionOpen] = useState(false)

    return (
        <>
            <Box
                onClick={() => setIsAccordionOpen(false)}
                position="fixed"
                role={'presentation'}
                top={0}
                left={0}
                width="100vw"
                height="100dvh"
                bg={isAccordionOpen ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0)'}
                transition="background-color 0.3s ease"
                pointerEvents={isAccordionOpen ? 'auto' : 'none'}
                cursor="pointer"
                data-testid="overlay"
            ></Box>
            <Accordion
                onChange={(value) =>
                    value === 0 ? setIsAccordionOpen(true) : setIsAccordionOpen(false)
                }
                allowToggle={true}
                index={isAccordionOpen ? 0 : -1}
                defaultIndex={isAccordionOpen ? 0 : -1}
                position="static"
                top={0}
                width="100%"
                backgroundColor={'white'}
                zIndex={1}
            >
                <AccordionItem
                    border="none"
                    backgroundColor={isAccordionOpen ? 'white' : 'gray.50'}
                    transition={'background-color 0.3s ease'}
                >
                    <AccordionButton data-testid="focused-accordion-button" padding={4}>{AccordionButtonContent}</AccordionButton>
                    <AccordionPanel>{AccordionPanelContent}</AccordionPanel>
                </AccordionItem>
            </Accordion>
        </>
    )
}

FocusedAccordion.propTypes = {
    AccordionPanelContent: PropTypes.any,
    AccordionButtonContent: PropTypes.any
}

export default FocusedAccordion
